import Path from "../../../../layouts/Path";
import {
  Button,
  Group,
  Stack,
  TagsInput,
  TextInput,
  Title,
} from "@mantine/core";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import { notifications } from "@mantine/notifications";
import BackButton from "../../../../components/View/BackButton";
import { createField, editField } from "../../../../api/ContactAPI";
import PageTitle from "../../../../components/View/PageTitle";

const EditDatafieldPage = () => {
  const datafield = useLoaderData();
  const lang = useLanguage((s) => s.language);
  const [possibleValues, setPossibleValues] = useState(
    datafield?.possible_values || []
  );
  const [searchValue, setSearchValue] = useState("");

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    let fd = new FormData(e.target);
    let data = Object.fromEntries(fd);

    setLoading(true);
    editField({ id: datafield?.id, name: data?.name, possible_values: possibleValues })
      .then((response) => {
        setTimeout(() => {
          notifications.show({
            message: lang.datafields.row_highlight.updated,
            color: "tertiary.8",
          });
        }, 300);
        navigate(`../?highlight=${datafield?.id}`);
      })
      .finally(() => setLoading(false));
  };
  return (
    <>
      <Group
        className="layout-block top"
        w={"100%"}
        gap={0}
        justify="space-between"
      >
        <PageTitle title={lang.datafields.browser_tab_title} />
      </Group>
      <Stack
        className="layout-block"
        w={"40%"}
        mx={"auto"}
        gap={"xs"}
        component={"form"}
        onSubmit={handleSubmit}
      >
        <Title order={5}>{lang.datafields.edit.dialog.title} : {datafield.name}</Title>
        <TextInput
          name="name"
          defaultValue={datafield?.name}
          label={lang.datafields.create.dialog.name}
          placeholder={lang.datafields.create.dialog.name}
          autoFocus
          required
        />

        <TagsInput
          label={lang.datafields.create.dialog.possible_values}
          placeholder={lang.datafields.create.dialog.possible_values}
          description={lang.datafields.create.dialog.possible_values_desc}
          value={possibleValues}
          onChange={setPossibleValues}
          onBlur={(e) => {
            let v = e.target.value;
            if (v) {
              setPossibleValues([...possibleValues, v]);
              setSearchValue("");
            }
          }}
          searchValue={searchValue}
          onSearchChange={setSearchValue}
        />

        <Group justify="flex-end" mt={"md"}>
          <BackButton />
          <Button type="submit" loading={loading}>
            {lang.datafields.edit.dialog.submit_button}
          </Button>
        </Group>
      </Stack>
    </>
  );
};

export default EditDatafieldPage;
